export var Status;
(function (Status) {
    /** Status is unknown or not specified. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** Earning rule is active and can assign points. */
    Status["ACTIVE"] = "ACTIVE";
    /** Earning rule is paused and can't assign points. */
    Status["PAUSED"] = "PAUSED";
})(Status || (Status = {}));
export var LoyaltyEarningRuleTypeTagType;
(function (LoyaltyEarningRuleTypeTagType) {
    /** Type is unknown or not specified. */
    LoyaltyEarningRuleTypeTagType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** Earning rule for a customer's birthday. */
    LoyaltyEarningRuleTypeTagType["BIRTHDAY"] = "BIRTHDAY";
})(LoyaltyEarningRuleTypeTagType || (LoyaltyEarningRuleTypeTagType = {}));
export var Type;
(function (Type) {
    /** Unknown type. This value is not used. */
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** Earning rule for social media. */
    Type["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
    /** Earning rule for birthdays. */
    Type["BIRTHDAY"] = "BIRTHDAY";
})(Type || (Type = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map